import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { ActionButton, TopNavigation } from "@hamlak/ui";
import { analytics } from "@/analytics";
import { t } from "@/i18n/ko";
import "@/features/auth/auth.css";

/**
 * 웹 결제 미지원 국가 안내 (상점·결제 설계 결정 17·19). 진입 1회 web_store_unsupported_viewed, '결제 지원 요청' 1회 payment_support_requested — 둘 다 country 만.
 * 이메일 등 개인정보는 받지 않는다. 지원 국가가 늘면 서버 SUPPORTED_REGIONS 로 열린다.
 */
export function StoreUnsupportedPage({ country }: { country: string | null }) {
  const navigate = useNavigate();
  const viewed = useRef(false);
  const [requested, setRequested] = useState(false);
  useEffect(() => {
    if (viewed.current) return;
    viewed.current = true;
    analytics.track("web_store_unsupported_viewed", { country: country ?? "unknown" });
  }, [country]);
  const request = () => {
    if (requested) return;
    setRequested(true);
    analytics.track("payment_support_requested", { country: country ?? "unknown" });
  };
  return (
    <main className="page auth" data-testid="store-unsupported">
      <TopNavigation title={t("page.store")} right={null} onBack={() => navigate(-1)} />
      <div className="auth__hero">
        <p className="auth__hero-text">{t("store.web.unsupported.title")}</p>
        <p className="auth__description" style={{ textAlign: "center" }}>
          {t("store.web.unsupported.body", { country: country ?? "-" })}
        </p>
        <ActionButton variant="brandSolid" disabled={requested} onClick={request}>
          {requested ? t("store.web.unsupported.requested") : t("store.web.unsupported.request")}
        </ActionButton>
      </div>
    </main>
  );
}
